import { EntityData, initialEntityData } from '@new/common/utils/entity-data';
import { PoolMetadataFragment } from '../../lib/services/pool/load-pool.generated';
import { UnlockedExamFragment } from '../../lib/services/tasks/unlocked-exams.generated';

export interface PoolStateModel {
  pool: EntityData<PoolMetadataFragment>;
  unlockedExams: EntityData<UnlockedExamFragment[]>;
}

export const poolStateDefaults: PoolStateModel = {
  pool: initialEntityData(),
  unlockedExams: initialEntityData()
};

/**
 * Raw function selectors for use by child states.
 * Avoids circular dependency with PoolState → children → PoolSelectors → PoolState.
 * TODO: Refactor to avoid this pattern
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type RootState = Record<string, any>;

export const selectPoolId = (state: RootState): string | undefined =>
  state.pool?.pool?.data?.id;

export const selectPoolAffiliations = (
  state: RootState
): PoolMetadataFragment['affiliations'] =>
  state.pool?.pool?.data?.affiliations ?? [];

export const selectPoolRevisionStatuses = (
  state: RootState
): PoolMetadataFragment['revisionStatus'] =>
  state.pool?.pool?.data?.revisionStatus ?? [];

export const selectPoolLabels = (
  state: RootState
): PoolMetadataFragment['labels'] => state.pool?.pool?.data?.labels ?? [];
export const selectPoolUnlockedExams = (
  state: RootState
): UnlockedExamFragment[] => state.pool?.unlockedExams?.data ?? [];
